import { SubscriptionPlan } from '@modules-deprecated/app/organization/enums/subscriptionPlan'

export const isValidSubscriptionPlan = (signupPlan?: any): signupPlan is SubscriptionPlan => {
  if (!signupPlan) {
    return false
  }

  return Object.values(SubscriptionPlan).includes(signupPlan)
}
